import { render } from "./AcsBoost.vue?vue&type=template&id=7de23cef&scoped=true&ts=true"
import script from "./AcsBoost.vue?vue&type=script&lang=ts"
export * from "./AcsBoost.vue?vue&type=script&lang=ts"

import "./AcsBoost.vue?vue&type=style&index=0&id=7de23cef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7de23cef"]])

export default __exports__